@let processing = appState.processing$ | async;

@for (crumb of breadcrumbs(); track $index) {
    <button mat-button mgdButton (click)="onClick(crumb)" [disabled]="crumb.last || processing">
        {{ crumb.value }}
    </button>

    @if (!crumb.last) {
    <mat-icon>
        keyboard_arrow_right
    </mat-icon>
    }

}